module.exports = __webpack_public_path__ + "static/media/lenders-logo.af3e490b.jpg";